<script>
  import { t } from "$lib/i18n/translations";
  import DownloadInputArea from "$components/downloadInputArea/Container.svelte";
  import DownloadData from "$components/downloadData/Box.svelte";
  import { page } from "$app/stores";
  import { getTypeFromPath } from "$lib/util";


  let titleStore = $t('general.main.title');
  let descStore = $t('general.main.description');
  $: { 
    const pathname = $page.url.pathname;
    const type = getTypeFromPath(pathname)
    if(type){
        titleStore = $t('general.main.title',{value:$t(`tabs.${type}`)});
        descStore =  $t('general.main.description',{value:$t(`tabs.${type}`)});
    } else {
        titleStore = $t('general.main.title',{value:$t('general.descriptionAll')});
        descStore = $t('general.main.description',{value:$t('general.descriptionAll')});
    }
  }
  
</script>

<!-- 主内容 -->
<main class="w-full">
  <div
    class="max-w-[1280px] mx-auto w-full flex flex-col items-center justify-center"
  >
    <!-- 标题 -->
    <div
      class="mt-[100px] text-center text-white px-[24px] max-mobile:mt-[56px]"
    >
      <h1
        class="max-mobile:!text-[28px] !text-[56px] !font-bold !mb-2 !leading-normal"
      >
        {titleStore}
      </h1>
      <p class="max-mobile:text-[14px] text-[18px] leading-normal">
        {descStore}
      </p>
    </div>

    <!-- 搜索组件 -->
    <DownloadInputArea />
   
    <!-- 搜索结果 -->
    <DownloadData />
  </div>
</main>
